var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F0F0F0"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M509.806,222.608c-7.062-53.986-31.312-106.152-72.787-147.627S343.377,9.255,289.391,2.193 l0.001,220.415L509.806,222.608L509.806,222.608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M222.608,2.193C168.622,9.255,116.455,33.505,74.98,74.98 C33.506,116.456,9.255,168.623,2.193,222.61l220.416-0.001L222.608,2.193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M2.193,289.392C9.255,343.378,33.506,395.546,74.98,437.02 c41.475,41.474,93.641,65.724,147.629,72.789l-0.001-220.415L2.193,289.392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M289.392,509.806c53.986-7.062,106.152-31.312,147.627-72.787s65.725-93.641,72.787-147.627H289.392 V509.806z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M343.389,162.438c0-3.404,2.767-6.171,6.172-6.171h13.224c20.904,0,37.911-17.006,37.911-37.909 s-17.006-37.91-37.911-37.91h-12.558c-4.099-3.079-9.598-4.978-15.664-4.978c-12.653,0-22.91,8.205-22.91,18.327 c0,10.024,10.061,18.156,22.545,18.314l-0.006,0.073h28.593c3.405,0,6.172,2.768,6.172,6.172s-2.767,6.171-6.172,6.171h-13.224 c-20.904,0-37.909,17.006-37.909,37.909s17.004,37.91,37.909,37.91h51.134v-31.738h-51.134 C346.156,168.609,343.389,165.842,343.389,162.438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M143.042,162.438c0-3.404,2.767-6.171,6.172-6.171h13.224c20.904,0,37.911-17.006,37.911-37.909 s-17.006-37.91-37.911-37.91h-12.558c-4.099-3.079-9.598-4.978-15.664-4.978c-12.653,0-22.91,8.205-22.91,18.327 c0,10.024,10.061,18.156,22.545,18.314l-0.006,0.073h28.594c3.405,0,6.172,2.768,6.172,6.172s-2.767,6.171-6.172,6.171h-13.224 c-20.904,0-37.909,17.006-37.909,37.909s17.004,37.91,37.909,37.91h51.133v-31.738h-51.134 C145.809,168.609,143.042,165.842,143.042,162.438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M343.389,398.62c0-3.404,2.767-6.171,6.172-6.171h13.224c20.904,0,37.911-17.006,37.911-37.909 s-17.006-37.91-37.911-37.91h-12.558c-4.099-3.079-9.598-4.978-15.664-4.978c-12.654,0-22.911,8.206-22.911,18.327 c0,10.024,10.061,18.156,22.545,18.314l-0.006,0.073h28.593c3.405,0,6.172,2.768,6.172,6.172c0,3.404-2.767,6.171-6.172,6.171 H349.56c-20.904,0-37.909,17.006-37.909,37.909s17.004,37.91,37.909,37.91h51.135v-31.737h-51.134 C346.156,404.792,343.389,402.023,343.389,398.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M143.042,398.62c0-3.404,2.767-6.171,6.172-6.171h13.224c20.904,0,37.911-17.006,37.911-37.909 s-17.006-37.91-37.911-37.91h-12.558c-4.099-3.079-9.598-4.978-15.664-4.978c-12.654,0-22.911,8.206-22.911,18.327 c0,10.024,10.061,18.156,22.545,18.314l-0.006,0.073h28.594c3.405,0,6.172,2.768,6.172,6.172c0,3.404-2.767,6.171-6.172,6.171 h-13.224c-20.904,0-37.909,17.006-37.909,37.909s17.004,37.91,37.909,37.91h51.134v-31.737h-51.134 C145.809,404.792,143.042,402.023,143.042,398.62z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMq);
export default __webpack_public_path__ + "static/media/mq.a2b431a8ca385bf0a764a32da0a84edd.svg";
export { ForwardRef as ReactComponent };